import { Component, OnInit } from '@angular/core';

declare var google;
@Component({
  selector: 'app-mapa',
  templateUrl: './mapa.component.html'
})

export class MapaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.iniciarMapa();
  }

  public iniciarMapa() {
    //Google Map init
    var googleMapSelector = $('#contactgoogleMap'),
      myCenter = new google.maps.LatLng(20.9722664, -89.6911527);

    var mapProp = {
      center: myCenter,
      zoom: 16,
      scrollwheel: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [
            { "color": "#444444" }
          ]
        },
        {
          "featureType": "landscape", "elementType": "all", "stylers": [
            { "color": "#f2f2f2" }
          ]
        },
        {
          "featureType": "poi", "elementType": "all", "stylers": [
            { "visibility": "off" }
          ]
        },
        {
          "featureType": "road", "elementType": "all", "stylers": [
            { "saturation": -100 },
            { "lightness": 45 }
          ]
        },
        {
          "featureType": "road.highway", "elementType": "all", "stylers": [
            { "visibility": "simplified" }
          ]
        },
        {
          "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [
            { "visibility": "off" }
          ]
        },
        {
          "featureType": "transit", "elementType": "all", "stylers": [
            { "visibility": "off" }
          ]
        },
        {
          "featureType": "water", "elementType": "all", "stylers": [
            { "color": "#46bcec" },
            { "visibility": "on" }
          ]
        }
      ]
    };
    var map = new google.maps.Map(document.getElementById("contactgoogleMap"), mapProp);
    var marker = new google.maps.Marker({
      position: myCenter,
      animation: google.maps.Animation.BOUNCE,
      icon: 'template/img/google-pin.png'
    });
    marker.setMap(map);
  }
}
